import React from "react";
import WorkFromHomeForm from "../../../../Utils/WorkFromHomeForm";
import axios from "axios";
import { usePopup } from "../../../../../context/popup-context/Popup";
import { Popup } from "../../../../Utils/Popup/Popup";

export default function WorkFromHome({ onClose }) {
  const { showPopup, setShowPopup, setMessage } = usePopup();

  const getCompanyCodeAndTokenFromCookies = () => {
    const cookies = document.cookie.split("; ");

    const companyCookie = cookies.find((cookie) =>
      cookie.startsWith("companyCode=")
    );

    const companyCode = companyCookie ? companyCookie.split("=")[1] : null;

    const employeeCookie = cookies.find((cookie) =>
      cookie.startsWith("employee_id=")
    );

    const employeeId = employeeCookie ? employeeCookie.split("=")[1] : null;

    return { companyCode, employeeId };
  };
  async function getData({ workHomeData }) {
    console.log("work from home data", workHomeData);
    const { companyCode, employeeId } = getCompanyCodeAndTokenFromCookies();
    if (!companyCode || !employeeId) {
      setShowPopup(true);
      setMessage("Missing company code or employee ID. Please try again.");
      setTimeout(() => setShowPopup(false), 3000);
      //alert("Missing company code or employee ID. Please try again.");
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/request/work_from_home`,
        workHomeData,
        { withCredentials: true }
      );
      console.log("API Response:", response.data);
      setShowPopup(true);
      setMessage("Work from home application submitted successfully!");
      setTimeout(() => setShowPopup(false), 3000);
      //alert("Work from home application submitted successfully!");
      onClose();
    } catch (error) {
      console.error("Error submitting Work From Home application:", error);
      setShowPopup(true);
      setMessage(
        "Failed to submit work from home application. Please try again."
      );
      setTimeout(() => setShowPopup(false), 3000);
      //alert("Failed to submit work from home application. Please try again.");
    }
  }
  return (
    <div>
      <WorkFromHomeForm getData={getData} />
      {showPopup && <Popup />}
    </div>
  );
}
